import { render, staticRenderFns } from "./aclass.vue?vue&type=template&id=6e4fae4e&scoped=true&"
import script from "./aclass.vue?vue&type=script&lang=js&"
export * from "./aclass.vue?vue&type=script&lang=js&"
import style0 from "./aclass.vue?vue&type=style&index=0&id=6e4fae4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4fae4e",
  null
  
)

export default component.exports